export default function HeroSection() {
  const scrollToSection = (sectionId: string) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section className="relative h-screen min-h-[800px] flex items-center justify-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://public.readdy.ai/ai/img_res/e69b2dba73cce0ae1b9726cfd21346a5.jpg"
          alt="Família feliz em Orlando"
          className="w-full h-full object-cover object-center"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/30 to-black/40"></div>
      </div>

      <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
        <div className="inline-block mb-6 px-4 py-2 border-2 border-white rounded-full">
          <span className="text-white font-medium text-sm">
            Especialistas em Orlando &amp; Disney
          </span>
        </div>

        <h1 className="text-5xl md:text-7xl font-bold text-white mb-6 leading-tight">
          Aluguel de Vans para<br />Família em Orlando
        </h1>

        <p className="text-xl md:text-2xl text-white mb-12 max-w-3xl mx-auto">
          Conforto, segurança e economia para sua viagem dos sonhos
        </p>

        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          <button
            onClick={() => scrollToSection('orcamento')}
            className="px-8 py-4 bg-[#c53030] text-white rounded-lg font-bold text-lg hover:bg-[#a02525] transition-all transform hover:scale-105 whitespace-nowrap cursor-pointer"
          >
            Calcular Orçamento Grátis
          </button>
          <button
            onClick={() => scrollToSection('frota')}
            className="px-8 py-4 bg-white/20 backdrop-blur-sm text-white border-2 border-white rounded-lg font-bold text-lg hover:bg-white/30 transition-all whitespace-nowrap cursor-pointer"
          >
            Ver Nossa Frota
          </button>
        </div>
      </div>

      <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2 animate-bounce">
        <i className="ri-arrow-down-line text-white text-3xl"></i>
      </div>
    </section>
  );
}
